/* eslint-disable react-hooks/exhaustive-deps */
import { mdiInformationOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { FunctionComponent, useEffect, useState } from "react";
import {
  PurchaseOrderModelV2,
  approval_level,
  approval_threshold,
  getPoApprovedCounts,
  levelModule,
  po_approval_status,
} from "../../model/purchase_order_model";
import ApprovalData from "./approval_data_sheet";
import StepperWidget from "../../../../ui/new_components/common/stepper_widget";
import {
  ModalAlignment,
  ModalType,
  useModal,
} from "../../../../context_providers/modal/modal_context";
import { useAuth } from "../../../../context_providers/auth/authProvider";
import { ACTION } from "../../../../utils/enums";
import { useHistory } from "react-router-dom";
import { urls } from "../../../../utils/urls";

interface ApprovalBottomSheetWidgetProps {
  data: PurchaseOrderModelV2;
  onSubmit: (data: { approval_status: string; level: string }) => void;
}

const ApprovalBottomSheetWidgetV2: FunctionComponent<
  ApprovalBottomSheetWidgetProps
> = (props) => {
  const { user, isAuthorised } = useAuth();
  const { showModal } = useModal();
  const [expanded, setExpanded] = useState(false);
  const [showActionBtn, setshowActionBtn] = useState(false);
  const [approvalCounts, setapprovalCounts] = useState<{
    [key: string]: number;
  }>({});
  const [approvalLevels, setapprovalLevels] = useState<{
    [key: string]: number;
  }>({});
  const navigation = useHistory();

  useEffect(() => {
    const counts = getPoApprovedCounts({ approvals: props.data.approvals });
    setapprovalCounts(counts);

    const rule =
      approval_threshold[props.data.approval_level || approval_level.level_0];

    const t = rule.approvals_required.reduce(
      (
        pv: {
          [key: string]: number;
        },
        v: { level: string; count: number },
      ) => ({ ...pv, [v.level]: v.count }),
      {},
    );

    setapprovalLevels(t);
  }, [props.data]);

  useEffect(() => {
    setshowActionBtn(
      (props.data.current_approval_required_count ?? 0) >
        (props.data.current_approval_count ?? 0) &&
        isAuthorised({
          action: ACTION.READ,
          module: levelModule[props.data.current_approval_level!],
        }),
    );
  }, [props.data]);
  const levels = Object.keys(approvalLevels);
  return (
    <div className="">
      {props.data.approval_level !== approval_level.level_0 && (
        <div className="mt-2 border rounded-md p-2 bg-gray-50 mb-2">
          <div className="pb-5">
            <StepperWidget
              steps={levels.map((level, i) => ({
                label: level,
                validated:
                  i < levels.indexOf(props.data.current_approval_level!) ||
                  (props.data.approval_level ===
                    props.data.current_approval_level &&
                    (props.data.current_approval_count ?? 0) >=
                      (props.data.current_approval_required_count ?? 0)),
                required: false,
              }))}
              activeStep={levels.indexOf(props.data.current_approval_level!)}
              onChange={function (step: number): void {
                showModal({
                  container: (i) => (
                    <div className="p-5">
                      <ApprovalData
                        approvals={
                          props.data.approvals?.filter(
                            (f) => f.level == levels[step],
                          ) ?? []
                        }
                        approved_count={approvalCounts[levels[step]] ?? 0}
                        approval_count_required={approvalLevels[levels[step]]}
                        approval_level={levels[step]}
                      />
                    </div>
                  ),
                  title: `${levels[step]} Approval Detail`,
                  type: ModalType.drawer,
                  alignment: ModalAlignment.right,
                });
              }}
            />
          </div>
        </div>
      )}
      <div className="flex flex-col justify-between sm:flex-col md:flex-row lg:flex-row ">
        <div className="">
          <div className="flex gap-1 text-gray-500 text-xs mt-2 items-center">
            <Icon path={mdiInformationOutline} size={0.8}></Icon>
            This Purchase order requires {props.data.approval_level} approval
          </div>
        </div>

        {showActionBtn && (
          <div className="flex items-end gap-5 my-5 text-sm">
            {props.data.approval_status !== "Rejected" && (
              <button
                id="po_approval_approve_btn"
                onClick={() => {
                  props.onSubmit({
                    approval_status: po_approval_status.approved,
                    level: props.data.current_approval_level!,
                  });
                }}
                className={`${
                  false
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-myPrimaryColor border border-myPrimaryColor"
                } rounded-md px-3 py-1 text-white`}
              >
                Approve
              </button>
            )}
            {props.data.approval_status !== "Rejected" && (
              <button
                id="po_approval_reject_btn"
                onClick={() => {
                  props.onSubmit({
                    approval_status: po_approval_status.rejected,
                    level: props.data.current_approval_level!,
                  });
                }}
                className={`${
                  false
                    ? "bg-gray-400 cursor-not-allowed"
                    : "border-myPrimaryColor"
                } rounded-md border px-3 py-1 text-myPrimaryColor`}
              >
                Reject
              </button>
            )}
            <button
              id="po_approval_quit_btn"
              onClick={() => {
                navigation.push(urls.purchase_order + "/approval");
              }}
              type="button"
              className="rounded-md border border-green-600 text-sm font-semibold bg-white text-black px-3 py-1"
            >
              Quit
            </button>
          </div>
        )}
        {!showActionBtn && (
          <div className="flex items-end gap-5 my-5 text-sm">
            <button
              id="po_approval_quit_btn_alt"
              onClick={() => {
                navigation.push(urls.purchase_order + "/approval");
              }}
              type="button"
              className="rounded-md border border-green-600 text-sm font-semibold bg-white text-black px-3 py-1"
            >
              Quit
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApprovalBottomSheetWidgetV2;
